import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { JSConn } from "@/utilities/js-conn";
import FormErrors from "@/components/FormErrors/FormErrors.vue";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { buildSubmitButton } from "@/utilities/form-helpers";

export default defineComponent({
  name: "logIn",
  components: {
    FormErrors,
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let email = ref("");
    let password = ref("");
    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading...");
    let hasFormErrors = ref(false);
    let formErrors = ref<string[]>([]);
    let firstInput = ref<null | HTMLElement>(null);

    let { submitButtonText, submitting } = buildSubmitButton();

    submitButtonText.value = "Log in";

    onMounted(() => {
      dataLoaded.value = true;
      ctx.root.$nextTick(() => {
        if (firstInput.value) {
          firstInput.value.focus();
        }
      });
    });

    const submitLogIn = (evt: any) => {
      evt.preventDefault();
      submitButtonText.value = "Logging in...";
      submitting.value = true;
      const jsConn = new JSConn();
      let x = window.matchMedia("(min-width: 768px)");

      if (x.matches) {
        jsConn.toRoutePath = "/work-queue";
      } else {
        jsConn.toRoutePath = "m/work-queue";
      }

      jsConn.formParams = {
        email: email.value,
        password: password.value,
      };
      $store
        .dispatch("logInUser", jsConn)
        .then(jsConn => {
          ctx.root.$router.push(jsConn.toRoutePath);
          return Promise.resolve(JSConn);
        })
        .catch(jsConn => {
          submitting.value = false;
          submitButtonText.value = "Log In";
          hasFormErrors.value = true;
          formErrors.value = jsConn.error["response"]["data"];
        });
    };

    return {
      email,
      password,
      dataLoaded,
      loadingMessage,
      hasFormErrors,
      formErrors,
      firstInput,

      submitLogIn,
      submitButtonText,
      submitting,
    };
  },
});
